import { chain } from "react-aria";
import { useControlledState } from "@react-stately/utils";

import { type TextInputV2Props } from "../TextInputV2";

type UseControlledValueProps = Pick<
  TextInputV2Props,
  "value" | "defaultValue" | "onChange"
>;

export function useControlledValue(props: UseControlledValueProps) {
  const [value, setValue] = useControlledState(
    props.value,
    props.defaultValue || ""
  );

  function handleChange(newValue: string) {
    return chain(props.onChange, setValue)(newValue.replace(/\D/g, ""));
  }

  return { value, handleChange };
}
